import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { defaultLocale, isValidLocale, type Locale } from '../i18n';

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    set => ({
      locale: defaultLocale,
      setLocale: locale => {
        if (isValidLocale(locale)) {
          set({ locale });
        }
      },
    }),
    {
      name: 'locale-storage',
    }
  )
);
